import { useEffect, useState } from 'react';
import { memberApi } from '@formosa/shared/api/member';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTranslation } from '../../i18n/LocaleContext';

const POP_DISMISS_PREFIX = 'formosa_pop_dismissed_';

export default function PopAnnouncementModal() {
  const { locale } = useTranslation();
  const [popData, setPopData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function loadPop() {
      try {
        const apiLang = resolveNewsApiLang(locale);
        const data = await memberApi.popAnnouncement({ lang: apiLang });
        if (cancelled) {
          return;
        }
        const hasContent = data && (data.title || data.body || data.image);
        if (!hasContent) {
          setPopData(null);
          setOpen(false);
          return;
        }
        const dismissed = sessionStorage.getItem(`${POP_DISMISS_PREFIX}${apiLang}`);
        setPopData(data);
        setOpen(!dismissed);
      } catch {
        if (!cancelled) {
          setPopData(null);
          setOpen(false);
        }
      }
    }

    loadPop();
    return () => {
      cancelled = true;
    };
  }, [locale]);

  function handleClose() {
    sessionStorage.setItem(`${POP_DISMISS_PREFIX}${resolveNewsApiLang(locale)}`, '1');
    setOpen(false);
  }

  if (!open || !popData) {
    return null;
  }

  return (
    <div className="trade-modal trade-modal--center pop-announcement-modal">
      <button
        type="button"
        className="trade-modal__backdrop"
        aria-label="關閉"
        onClick={handleClose}
      />
      <div className="pop-announcement-modal__panel" role="dialog" aria-modal="true">
        <header className="pop-announcement-modal__header">
          <h2>{popData.title || ''}</h2>
          <button
            type="button"
            className="trade-modal__close"
            aria-label="關閉"
            onClick={handleClose}
          >
            ×
          </button>
        </header>

        {popData.image ? (
          <div className="pop-announcement-modal__image-wrap">
            <img src={resolveMemberMediaUrl(popData.image)} alt="" className="pop-announcement-modal__image" />
          </div>
        ) : null}

        {popData.body ? (
          <div
            className="pop-announcement-modal__body"
            dangerouslySetInnerHTML={{ __html: popData.body }}
          />
        ) : null}
      </div>
    </div>
  );
}
